<template>
  <div class="simple-form-skeleton" aria-hidden="true">
    <div class="simple-form-skeleton__title" />
    <div class="simple-form-skeleton__ref" />
    <div class="simple-form-skeleton__row">
      <div class="simple-form-skeleton__field" />
      <div class="simple-form-skeleton__field" />
    </div>
    <div class="simple-form-skeleton__row">
      <div class="simple-form-skeleton__field" />
      <div class="simple-form-skeleton__field" />
    </div>
    <div class="simple-form-skeleton__field simple-form-skeleton__field--wide" />
    <div class="simple-form-skeleton__divider" />
    <div class="simple-form-skeleton__line" />
    <div class="simple-form-skeleton__line simple-form-skeleton__line--short" />
    <div class="simple-form-skeleton__button" />
    <div class="simple-form-skeleton__footer" />
    <div class="simple-form-skeleton__footer simple-form-skeleton__footer--wide" />
  </div>
</template>

<style lang="scss" scoped>
.simple-form-skeleton {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 8px 0 32px;

  @media screen and (min-width: 1024px) {
    padding-bottom: 0;
  }
}

.simple-form-skeleton__title,
.simple-form-skeleton__ref,
.simple-form-skeleton__field,
.simple-form-skeleton__divider,
.simple-form-skeleton__line,
.simple-form-skeleton__button,
.simple-form-skeleton__footer {
  border-radius: 6px;
  background: linear-gradient(90deg, #f3f3f3 0%, #ecebeb 50%, #f3f3f3 100%);
  background-size: 200% 100%;
  animation: simple-skeleton-shimmer 1s linear infinite;
}

.simple-form-skeleton__title {
  width: 55%;
  height: 28px;
  margin: 0 auto 16px;
}

.simple-form-skeleton__ref {
  height: 48px;
  margin-bottom: 16px;
}

.simple-form-skeleton__row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 12px;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
}

.simple-form-skeleton__field {
  height: 56px;

  &--wide {
    margin-bottom: 16px;
  }
}

.simple-form-skeleton__divider {
  height: 1px;
  margin: 8px 0 16px;
  opacity: 0.7;
}

.simple-form-skeleton__line {
  height: 18px;
  margin-bottom: 12px;

  &--short {
    width: 72%;
    margin-bottom: 24px;
  }
}

.simple-form-skeleton__button {
  height: 44px;
  border-radius: 160px;
  margin-bottom: 24px;
}

.simple-form-skeleton__footer {
  width: 48%;
  height: 16px;
  margin: 0 auto 10px;

  &--wide {
    width: 70%;
  }
}

@keyframes simple-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
